<template>
    <validation-provider
        :name="name"
        :rules="rules"
        v-slot="{ errors, failed, changed, validated }"
    >
        <div class="form-element-container">
            <div
                :class="{
                    ['form-element input input-error ' + `${computedClasses}`]:
                        failed && (changed || validated),
                    ['form-element input ' + `${computedClasses}`]: !(
                        failed &&
                        (changed || validated)
                    ),
                }"
            >
                <label
                    class="label-input"
                    :for="inputId"
                    v-html="label"
                ></label>

                <input
                    :type="type"
                    :name="name"
                    :id="inputId"
                    v-model="inputValue"
                />
            </div>

            <p class="error-text" v-if="failed && (changed || validated)">
                {{ errorMessage }}
            </p>
        </div>
    </validation-provider>
</template>

<script>
export default {
    props: {
        name: { type: String, required: true },
        inputId: { type: String, required: true },
        label: { type: String, default: '' },
        rules: { type: String, default: '' },
        value: { type: String, default: '' },
        type: { type: String, default: 'text' },
        errorMessage: { type: String, default: '' },
        additionalClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
        computedClasses() {
            return ['', this.additionalClass];
        },
    },
};
</script>
